import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyPhoneSalesFail from './components/WhyPhoneSalesFail';
import TasksSolved from './components/TasksSolved';
import WhyPhoneSalesChanged from './components/WhyPhoneSalesChanged';
import WhenNeeded from './components/WhenNeeded';
import SkillsLearned from './components/SkillsLearned';
import HowTrainingGoes from './components/HowTrainingGoes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CallBeforeAfter from './components/CallBeforeAfter';
import CaseResults from './components/CaseResults';
import Formats from './components/Formats';
import SuitableCompanies from './components/SuitableCompanies';
import CompanyResults from './components/CompanyResults';
import AboutAuthor from './components/AboutAuthor';
import CTASection from './components/CTASection';
import FinalCTA from './components/FinalCTA';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Программа', target: 'program' },
  { label: 'Кейсы', target: 'cases' },
  { label: 'Форматы', target: 'formats' },
  { label: 'FAQ', target: 'faq' },
];

export default function PhoneSalesTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по телефонным продажам | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyPhoneSalesFail />
        <TasksSolved />
        <WhyPhoneSalesChanged />
        <WhenNeeded />
        <SkillsLearned />
        <HowTrainingGoes />
        <WhyProgramsWork />
        <CallBeforeAfter />
        <CaseResults />
        <CompanyResults />
        <Formats />
        <SuitableCompanies />
        <AboutAuthor />
        <CTASection />
        <FinalCTA />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}